import { isNumber } from 'lodash';
import React, { FC, useRef, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getMemberInfo } from 'src/utils/common';

import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { fetchInsertCardData, fetchUpdateCardData } from 'src/fetch/stepC/card';
import { addComma } from 'src/utils/common';
import { creditcardDataStore } from 'src/store/creditcard';
import { initCreditCardPayload } from 'src/store/creditcard';
import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import CheckBox from 'src/components/atoms/CheckBox';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import Description from 'src/components/molecules/table/Description/CreditCard';
import DefLabel from 'src/components/atoms/label/LabelContnet';

interface Props {
  cardType?: string;
  type: string;
  data?: any;
}
const CreditGridAdd: FC<Props> = ({ cardType, type, data }) => {
  const userInfoData: any = getMemberInfo();

  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  const cardData = creditcardDataStore((state: any) => state.result).data || [];
  const creditInitPayload = creditcardDataStore((state: any) => state.initPayload);
  const creditPayload = creditcardDataStore((state: any) => state.payload);
  const creditPayloadBind = creditcardDataStore((state: any) => state.bindPayload);
  const bindCreditCardParam = creditcardDataStore((state: any) => state.param);
  const bindCreditCardBindParam = creditcardDataStore((state: any) => state.bindParam);

  // const dataSet = cardData.filter((item: any) => item.creditCard !== undefined);
  const familyDataSet = cardData.filter((item: any) => item.cardData === undefined);
  const familySet = familyDataSet.map((item: any) => {
    return { id: item.family_seqid, value: item.name };
  });
  familySet.unshift({ id: '', value: '선택' });

  let data_type = 'G0012';
  if (cardType === 'credit') {
    data_type = 'G0012';
  } else if (cardType === 'debit') {
    data_type = 'G0014';
  } else if (cardType === 'cash') {
    data_type = 'G0013';
  } else if (cardType === 'zero') {
    data_type = 'G0014B';
  }

  useEffect(() => {
    if (type === 'insert') {
      creditPayloadBind({ ...creditInitPayload, data_type });
    } else {
      const creditData = data.cardData;
      console.log('creditData:', data);
      for (const key in creditPayload) {
        creditPayload[key] = creditData[key];
      }
      creditPayloadBind({ ...creditPayload, data_type, name: data.name });
    }
  }, []);

  const checkedFamily =
    creditPayload.family_seqid === 0
      ? familySet[0]
      : { id: creditPayload.family_seqid, value: creditPayload.name };

  const familySelect = {
    checked: checkedFamily,
    options: familySet,
  };

  const confirmSelect = (item: any, field: string) => {
    creditPayloadBind({ ...creditInitPayload, family_seqid: item.id, name: item.value, data_type });
  };

  // INSERT
  const confirmEvt = () => {
    creditPayload.acct_year = userInfoData.acct_year;
    creditPayload.co_cd = userInfoData.co_cd;
    creditPayload.co_id = userInfoData.co_id;
    const param: any = creditPayload;

    console.log('insert param:::', param);
    // return false;
    fetchInsertCardData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindCreditCardParam.initialSeq || 0;
      bindCreditCardBindParam({ initialSeq: initialSeq + 1 });
      setContentModalState({
        active: '',
      });
    });
  };

  // UPDATE
  const modifyEvt = () => {
    creditPayload.acct_year = userInfoData.acct_year;
    creditPayload.co_cd = userInfoData.co_cd;
    creditPayload.co_id = userInfoData.co_id;
    const param: any = creditPayload;
    // return false;
    fetchUpdateCardData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindCreditCardParam.initialSeq || 0;
      bindCreditCardBindParam({ initialSeq: initialSeq + 1 });
      setContentModalState({
        active: '',
      });
    });
  };

  const checkClickEvt = (e: React.MouseEvent, type: string) => {
    let useYN = 'Y';
    if (type === 'on') useYN = 'N';
    creditPayloadBind({ ...creditPayload, is_htx_pdf: useYN });
  };

  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let chkValue = e.target?.value || '';
    chkValue = chkValue.replaceAll(',', '');
    const chkNum = Number(chkValue);
    if (chkNum || chkNum === 0) {
      creditPayload[key] = chkNum;
      creditPayloadBind({ ...creditPayload });
    }
  };

  const help = {
    content: `
      <div className="_hint_content">
        <div className="_item">부양가족(연령불문,형제자매 제외)의 신용카드 등 사용금액에 대하여 공제가능합니다.</div>
        <div className="_item">본인을 포함한 전체 사용자의 카드등 사용액 합계가 <span className="_h1">총급여의 25% 이상</span>이어야 공제가능합니다.</div>
        <div className="_item">근무 기간 중 사용액은 2023년 전체 사용액 중 근무기간에 사용한 금액을 입력하여야 합니다.</div>
      </div>
      `,
    title: '내역 추가',
  };

  const setGridDiv = () => {
    return (
      <div className="_table_grid_layout">
        <div className="_grid">
          <div className="_label">
            <div className="_row">
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">일반사용액</div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">전통시장</div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">대중교통</div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">도서 공연등</div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h0">
                    <div className="_i_col">주택임차료</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="_content">
            <div className="_row _i_h2">
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h2">
                    <div className="_i_col _w_p_50 _ft_lb_t2">
                      <InputBox
                        boxStyleDef={{ width: 'calc(100% - 20px)' }}
                        value={addComma(creditPayload.use_place_cd01)}
                        changeEvt={e => inpChangeEvt(e, 'use_place_cd01')}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h2">
                    <div className="_i_col _w_p_50 _ft_lb_t2">
                      <InputBox
                        boxStyleDef={{ width: 'calc(100% - 20px)' }}
                        value={addComma(creditPayload.use_place_cd02)}
                        changeEvt={e => inpChangeEvt(e, 'use_place_cd02')}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h2">
                    <div className="_i_col _w_p_50 _ft_lb_t2">
                      <InputBox
                        boxStyleDef={{ width: 'calc(100% - 20px)' }}
                        value={addComma(creditPayload.use_place_cd03)}
                        changeEvt={e => inpChangeEvt(e, 'use_place_cd03')}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h2">
                    <div className="_i_col _w_p_50 _ft_lb_t2">
                      <InputBox
                        boxStyleDef={{ width: 'calc(100% - 20px)' }}
                        value={addComma(creditPayload.use_place_cd04)}
                        changeEvt={e => inpChangeEvt(e, 'use_place_cd04')}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="_col _w_p_40">
                <div className="_cont">
                  <div className="_i_row _i_h2">
                    <div className="_i_col _w_p_50 _ft_lb_t2">
                      <InputBox
                        boxStyleDef={{ width: 'calc(100% - 20px)' }}
                        value={addComma(creditPayload.use_place_cd05)}
                        changeEvt={e => inpChangeEvt(e, 'use_place_cd05')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const viewFamilySet = () => {
    if (type === 'insert') {
      if (familyDataSet.length === 0) {
        return (
          <>
            <div className="_no_select">
              <div className="_label">추가 할 수 있는 부양가족이 없습니다.</div>
              <div className="_label_desc">'가족정보' 메뉴에서 부양가족을 추가 할 수 있습니다.</div>
            </div>
            <div className="_description _disable">
              <Description />
            </div>
          </>
        );
      }

      return (
        <>
          <div className="_opt_div">
            <div className="_item" style={{ zIndex: 10, width: '350px' }}>
              <LabelSelect
                label="부양가족"
                select={familySelect}
                labelStyle={{ width: '100px' }}
                boxStyleDef={{ width: 'calc(100% - 100px)' }}
                confirmEvent={confirmSelect}
                field="relation"
              />
            </div>
          </div>
          {creditPayload.family_seqid === 0 ? (
            <div className="_no_select">
              <div className="_label">부양가족을 선택해 주세요.</div>
            </div>
          ) : (
            <div className="_grid_div">
              <div className="_bg"></div>
              <div className="_item">
                <CheckBox
                  label="국세청 금액 여부"
                  selected={creditPayload.is_htx_pdf === 'Y' ? 'on' : 'off'}
                  btnClickEvt={checkClickEvt}
                  labelStyleDef={{ color: '#333', fontWeight: '500', width: '120px' }}
                />
              </div>
              <div className="_view">{setGridDiv()}</div>
            </div>
          )}
          <div className="_description">
            <Description />
          </div>
          <div className="_btn_div">
            <DefaultButton
              text="내역 추가"
              styleDef={{ width: '250px' }}
              clickEvent={e => confirmEvt()}
              icon=""
              type="type5"
            />
          </div>
        </>
      );
    }
    // Update
    return (
      <>
        <div className="_title_div">
          <DefLabel
            label="부양가족 명"
            content={creditPayload.name || ''}
            styleDef={{ color: '#333', fontWeight: '600', fontSize: '15px' }}
            labelStyleDef={{
              fontWeight: '500',
              fontSize: '14px',
              // width: '80px',
              paddingRight: '10px',
            }}
          />
        </div>
        <div className="_grid_div">
          <div className="_item">
            <CheckBox
              label="국세청 금액 여부"
              selected={creditPayload.is_htx_pdf === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '120px' }}
            />
          </div>
          <div className="_view">{setGridDiv()}</div>
          <div className="_btn_div">
            <DefaultButton
              text="내역 변경"
              styleDef={{ width: '250px' }}
              clickEvent={e => modifyEvt()}
              icon=""
              type="type3"
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="_add_credit_layout">
      {/* <div className="_desc_div">
        <div className="_main">총 급여의 25% : 10,000,000</div>
        <div className="_sub">신용카드등은 총급여의 25% 이상이어야 공제 가능합니다.</div>
      </div> */}
      <div className="_title_div">
        <div className="_title">내역</div>
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} styleDef={{ width: '580px' }} />
        </div>
      </div>
      <div className="_inp_div">{viewFamilySet()}</div>
    </div>
  );
};

export default CreditGridAdd;
